// extracted by mini-css-extract-plugin
var _1 = "I3bQuiUSERUBOP8Z8KQp";
var _2 = "T3jkS9al74_RkxApEft5";
var _3 = "icHe42YBLz6ev1ggoRwV";
var _4 = "e1xJMseRgbprxhjtxzHg";
export { _1 as "body", _2 as "close", _3 as "collectEmail", _4 as "terms" }
